import type { ReactNode } from "react";
import { Text } from "react-native";
import type { StyleProp, TextStyle } from "react-native";
import { semanticColors } from "../theme/tokens";

type Props = {
  children: ReactNode;
  numberOfLines?: number;
  style?: StyleProp<TextStyle>;
};

/**
 * Small supporting metadata used for provenance, detail, and secondary
 * context inside otherwise primary content surfaces.
 */
export function MetaText({ children, numberOfLines, style }: Props) {
  return (
    <Text
      className="font-dm-sans"
      numberOfLines={numberOfLines}
      style={[
        {
          fontSize: 12,
          lineHeight: 16,
          color: semanticColors.text.tertiary,
          fontWeight: "500",
          marginTop: 2,
        },
        style,
      ]}
    >
      {children}
    </Text>
  );
}

export default MetaText;
